import './Score.scoped.scss'
import useTranslatableFlow from 'FlowBuilder/hooks/useTranslatableFlow'
import { questionTranslatablesScore } from 'FlowBuilder/lib/questionTranslatable'

export default function Score({ response, setResponse, name, settings, textContent, className = '' }) {
  const isDashboard = useSel(s => !!s.dashboard?.id)
  const translated = useTranslatableFlow({ textContent, translatableConfiguration: questionTranslatablesScore })

  const handleChange = (event) => {
    if (event.target.checked) {
      setResponse(+event.target.value);
    }
  }

  const options = (new Array((settings.max || 10) - (settings.min ?? 0)+1))
    .fill(0).map((item, index) => index + (settings.min ?? 0))

  if (isDashboard) {
    return <div className={`answers dropdown ${className}`}>
      <select
        name={name}
        value={response ?? ''}
        onChange={e => setResponse(e.target.value === "" ? null : +e.target.value)}
      >
        <option value="">Select...</option>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  }

  const scoreLabelLeft = translated.scoreLabelLeft || settings?.scoreLabelLeft || ''
  const scoreLabelRight = translated.scoreLabelRight || settings?.scoreLabelRight || ''
  const hasLabels = scoreLabelLeft || scoreLabelRight

  return (
    <div className={`score-container ${className}`}>
      {hasLabels && (
        <div className="score-labels">
          <span className="score-label-left">{scoreLabelLeft}</span>
          <span className="score-label-right">{scoreLabelRight}</span>
        </div>
      )}
      <div className="answers">
        {options.map((option) => (
          <label key={option} className={`${option === response ? 'selected' : ''}`}>
            <input type="radio"
              name={name}
              value={option}
              checked={option === response}
              onChange={handleChange} />
            <span>{option}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
